export default {
	getAccountsList(state) {
		return state.accountsList;
	}
}
